import { render, staticRenderFns } from "./VersionRank.vue?vue&type=template&id=416ae974&scoped=true"
import script from "./VersionRank.vue?vue&type=script&lang=js"
export * from "./VersionRank.vue?vue&type=script&lang=js"
import style0 from "./VersionRank.vue?vue&type=style&index=0&id=416ae974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416ae974",
  null
  
)

export default component.exports